import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Subscription } from 'rxjs';
import { AttributeModel, attributePresetTypes, ReferenceParams } from 'src/app/models';
import { ApiAttributesMappingService, LanguageService, NotificationService } from 'src/app/services';
import { ApiAttributesService } from 'src/app/services/api-attributes.service';
import { ApiUserOrgRolesService } from 'src/app/services/api-user-org-roles.service';

@Component({
  selector: 'app-accsess-to-attributes',
  templateUrl: './accsess-to-attributes.component.html',
  styleUrls: ['./accsess-to-attributes.component.css']
})
export class AccsessToAttributesComponent implements OnInit {

  subscriptions: Subscription = new Subscription();
  language: string;
  dragEnabled = true;
  allAttributes: any[] = [];
  myAttributes: AttributeModel[] = [];
  attributeGroups: any[] = [];
  attributeGroupsAccess: any;
  attributes: any[] = []
  attrValue: any;
  checkIsEmpty: boolean[] = [];
  checkIsEmptyCheckBox: boolean[] = [];
  selectedAttribute: any[][] = [];
  roleId: string;
  attributeAccessAllEdit: boolean;
  attributeAccessAllRead: boolean;
  @Input() userRoleId: string;


  searchForm: UntypedFormGroup = this.formb.group({
    search: [null],
    searchAttr: [null]
  })

  form: UntypedFormGroup = this.formb.group({
    id: [null],
    org_id: [null],
    urole_in_org_id: [null],
    name: [null],
    label: [null],
    attr_id: [null]
  });


  constructor(
    private languageService: LanguageService,
    private apiAttributes: ApiAttributesService,
    public activeModal: NgbActiveModal,
    private formb: UntypedFormBuilder,
    private apiUserOrgService: ApiUserOrgRolesService,
    private notification: NotificationService,
    private apiAttrsMappingService: ApiAttributesMappingService,
  ) { }

  ngOnInit(): void {

    this.roleId = this.userRoleId;

    this.subscriptions.add(
      this.languageService.listenerLanguage().subscribe(val => {

        this.language = val.language;
      })
    );


    this.subscriptions.add(
      this.apiUserOrgService.listenerRoleId().subscribe(val => {

        if (val) {

          this.roleId = val;

        }

      })
    );

    this.getAttributesTypes();

  }

  ngOnDestroy(): void {

    this.subscriptions.unsubscribe();
  }


  /**
   * 
   */
  getAttributesTypes(refreshState?:boolean): void {

    let params: ReferenceParams = {
      ref_name: 'attribute_groups',
      filter: {
        urole_id: this.roleId
      }
    }

    this.subscriptions.add(
      this.apiAttrsMappingService.getReferences(params, params.ref_name).subscribe((response: any) => {
        console.log("GROUPS: ", response);


        if (response != null) {

          this.attributeGroups = response.result.data;

          if(!refreshState){
            
            this.attributeAccessAllEdit = response.result.all_edit;
            this.attributeAccessAllRead = response.result.all_read;
          }
         
        }
      })
    );

  }



  /**
   * 
   * @param attributeGroupId 
   * @param attributeGroupIndex 
   * @param state 
   */
  isOpenItem(attributeGroupId: string, attributeGroupIndex: number, state: boolean) {

    state ? this.getAttributes(attributeGroupId, attributeGroupIndex) : this.attributes[attributeGroupIndex] = null, this.checkIsEmpty[attributeGroupIndex] = false, this.checkIsEmptyCheckBox[attributeGroupId] = false;

  }


  /**
   * 
   * @param event 
   * @param attributeGroupIndex 
   * @param actionType 
   * @param attributeGroupId 
   * @param state 
   */
  prepariedAttributesList(event: any, attributeGroupIndex: number, actionType: string, attributeGroupId: string, state: boolean) {

    state ? this.getAttributes(attributeGroupId, attributeGroupIndex, event, actionType) : this.checkAllCheckBox(event, attributeGroupIndex, actionType);

  }

  /**
  * 
  * @param attribute_group_id 
  * @param index 
  */
  getAttributes(attributeGroupId: string, attributeGroupIndex: number, event?: any, actionType?: string): void {

    let params: ReferenceParams = {
      ref_name: 'attrs_for_roles',
      filter: {
        attr_group_id: attributeGroupId,
        urole_id: this.roleId
      }
    }

    this.subscriptions.add(
      this.apiAttrsMappingService.getReferences(params, params.ref_name).subscribe((response: any) => {
        console.log("ATTRIBUTES LIST: ", response);

        if (response != null && response.result != null) {

          this.attributes[attributeGroupIndex] = response.result;

          // this.attributes[attributeGroupIndex].forEach((val, i) => {

          //   this.attributeForEdit[i] = val.edit;
          //   this.attributeForRead[i] = val.read;
          // });

          if (actionType) {

            this.checkAllCheckBox(event, attributeGroupIndex, actionType);
          }

          //Разблокировака чекбоксов для массовых выбора/снятия выделения
          this.checkIsEmptyCheckBox[attributeGroupIndex] = true;

        } else {

          this.checkIsEmpty[attributeGroupIndex] = true;
        }


      })
    );

  }


  /**
   * 
   */
  getAccessToAllAttributes(event: any, attrType: string) {


    let attr = {
      id: 'all',
      edit: this.attributeAccessAllEdit,
      read: this.attributeAccessAllRead
    }

    if (attrType) {

      attr[attrType] = event.target.checked;
    }

    if (event.target.checked) {

      this.onCreate(attr);

    } else {

      this.onDelete(attr);
    }
  }



  /**
   * 
   * @param event 
   * @param attributeGroupIndex 
   * @param actionType 
   */
  checkAllCheckBox(event: any, attributeGroupIndex: number, actionType: string): void {

    if (this.attributes[attributeGroupIndex] != null) {

      this.attributes[attributeGroupIndex].forEach(x => x[actionType] = event.target.checked);

      this.attributes[attributeGroupIndex].forEach((element) => {

        this.checkboxEvent(event, element);

      });
    }

  }


  /**
   * 
   * @param event 
   * @param attrId 
   * @param attributeIndex 
   */
  checkboxEvent(event: any, attr: any, attrType?: string) {

    if (attrType) {

      attr[attrType] = event.target.checked;
    }

    if (event.target.checked) {

      this.onCreate(attr);

    } else {

      this.onDelete(attr);
    }
  }


  /**
  * 
  * @returns boolean
  */
  checkedButNotAllCheckBox(groupIndex: number): boolean {

    if (this.attributes[groupIndex]) {

      let pl = this.attributes[groupIndex].length;
      let pc = this.attributes[groupIndex].filter(val => val.checked).length;

      return (pc > 0 && pc < pl) ? true : false;
    }
  }

  /**
  * 
  * @returns boolean
  */
  isAllCheckBoxChecked(groupIndex: number): boolean {

    if (this.attributes[groupIndex]) {

      if (this.attributes[groupIndex].length == 0) return false;

      return this.attributes[groupIndex].every(p => p.checked);
    }
  }

  // /**
  //  * 
  //  * @param e 
  //  * @param type 
  //  */
  // onDrop(e: any, type: string) {

  //   if (type == 'all') {

  //     let checkDuplicates = this.myAttributes.findIndex(val => val.id == e.dragData.id);

  //     if (checkDuplicates > -1) return;

  //     this.myAttributes.unshift(e.dragData);
  //     this.removeItem(e.dragData, this.allAttributes);
  //     // this.onCreate(e.dragData.id);

  //   } else {

  //     let checkDuplicates = this.allAttributes.findIndex(val => val.id == e.dragData.id);

  //     if (checkDuplicates > -1) return;

  //     this.allAttributes.unshift(e.dragData);
  //     this.removeItem(e.dragData, this.myAttributes);
  //     // this.onDelete(e.dragData.id)
  //   }

  // }

  // /**
  //  * 
  //  * @param item 
  //  * @param list 
  //  */
  // removeItem(item: any, list: Array<any>) {

  //   let index = list.map(function (e) {
  //     return e.name
  //   }).indexOf(item.name);
  //   list.splice(index, 1);
  // }

  /**
  * 
  */
  onCreate(attr: any): void {

    let params: any = {

      attribute_id: attr.id,
      urole_id: this.roleId,
      edit: attr.edit,
      read: attr.read

    }

    this.subscriptions.add(
      this.apiAttributes.createAccessToAttribute(params).subscribe((response: any) => {

        if (response != null) {

          this.notification.show('success', 'Доступ к атрибуту успешно открыт!');
          this.getAttributesTypes(true);

        }
      })
    );
  }


  /**
  * 
  */
  onDelete(attr: any): void {

    let params: any = {
      urole_id: this.roleId,
      attribute_id: attr.id,
      edit: attr.edit,
      read: attr.read
    }

    this.subscriptions.add(
      this.apiAttributes.deleteAccessToAttributes(params).subscribe((response: any) => {

        if (response != null) {

          this.notification.show('success', 'Доступ к атрибуту успешно ограничен!');
          this.getAttributesTypes(true);
        }
      })
    );
  }

}
